import { getBrandFocusRing } from '../focus';
export const tabs = (theme) => ({
    sizes: {
        sm: {
            fontSize: theme.fontSizes?.sm,
            padding: '4px 8px',
        },
        md: {
            fontSize: theme.fontSizes?.md,
            padding: '6px 12px',
        },
        lg: {
            fontSize: theme.fontSizes?.lg,
            padding: '8px 16px',
        },
    },
    text: {
        color: {
            default: theme.colors?.text?.basic?.secondary,
            selected: theme.colors?.text?.basic?.primary,
            disabled: theme.colors?.text?.basic?.disabled,
        },
        fontWeight: theme.fontWeights?.[500],
        lineHeight: theme.lineHeights?.mRoomy,
    },
    helper: {
        fontSize: {
            sm: theme.fontSizes?.xs,
            md: theme.fontSizes?.sm,
            lg: theme.fontSizes?.sm,
        },
        color: {
            default: theme.colors?.text?.basic?.tertiary,
            selected: theme.colors?.foreground?.brand,
            disabled: theme.colors?.text?.basic?.disabled,
        },
        marginLeft: theme.space?.space8,
        fontWeight: theme.fontWeights?.[500],
    },
    hover: {
        background: theme.colors?.component?.hover,
    },
    activeHover: {
        background: theme.colors?.component?.alt?.hover,
    },
    indicator: {
        color: theme.colors?.foreground?.brand,
        size: theme.space?.space4,
        transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        gap: theme.space?.space12,
    },
    baseline: {
        color: theme.colors?.border?.subtle,
        size: theme.space?.space1,
    },
    container: {
        minWidth: '96px',
        borderRadius: theme.radii?.sm,
    },
    item: {
        gap: theme.space?.space4,
        focusRing: getBrandFocusRing(theme),
    },
});
//# sourceMappingURL=tabs.js.map